import React, { useState, useEffect } from "react";
import {isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { useFetch } from "../../api/FetchApiData";
if (isMobile)
    import('./orders_mob.css').then(() => {});
else
    import('./orders.css').then(() => {});

export default function UserOrders({User,setUser})
{
    const [orders,setOrders] = useState([]);
    const navigator = useNavigate();
    const fetchData = useFetch();

    useEffect(()=>{
        let user_id = User.id;
        if(user_id === undefined || user_id === null)
            user_id = 'self';
        fetchData.GetData(`user/order/${user_id}/all/1/`).then(result=>{
            if(result.result)
                setOrders([...result.orders]);
        });
    },[User]);
    
    const ShowOrders=()=>
    {        
        if(orders.length===0)
        {
            return(
                <tr><td colSpan={4}>Aucune commande enregistrée</td></tr>
            );
        }
        else
        {
            return(
                orders.slice().reverse().map((order)=>{
                    let color_status = 'black';
                    if(order.status == 'livrée')
                        color_status = 'green';
                    else if(order.status == 'expediée')
                        color_status = 'blue';
                    let color_payment = 'green';
                    if(order.remained_price>0)
                        color_payment = 'red';
                return (
                    <tr onClick={e=>{navigator(`/order/object/${order.id}`)}} key={orders.indexOf(order)}>
                        <td colSpan={1} className="orders-history-td" style={{borderBottom:'1px solid lightgray'}} >
                            {order.order_number}<br/>
                            <label style={{color:'gray',fontSize:'x-small'}}>{order.date.split('T')[0]}</label>
                        </td>
                        <td colSpan={1} className="orders-history-td" onClick={(e)=>{}} style={{borderBottom:'1px solid lightgray',fontWeight:'bold',color:color_payment}}>Reste : {order.remained_price} €<span style={{fontWeight:'bold'}}></span></td>
                        <td colSpan={1} className="orders-history-td" onClick={(e)=>{}} style={{borderBottom:'1px solid lightgray',fontWeight:'bold',color:color_status}}>{order.status.status.toUpperCase()}</td>
                    </tr>
                )
            }));
        }
        
    }

    return(
        <div id="orders-history">
                <table className="orders-history-table">
                    <thead>
                        <tr style={{backgroundColor:'goldenrod'}}>
                            <th className="orders-history-td" style={{borderTopLeftRadius:'5px'}}>Numéro</th>
                            <th className="orders-history-td" style={{}}>Paiement</th>
                            <th className="orders-history-td" style={{borderTopRightRadius:'5px'}}>Statut</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ShowOrders()}
                    </tbody>     
                </table>    
        </div>
    );
}